/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { CheckRedeemService } from '../../../CheckRedeemService';
import { CheckRedeemRequest } from '../model/CheckRedeemRequest';
import { createRequestBuilder, HttpHeaders, HttpRequest } from '@quickplay/foundation';
import { CheckRedeemResponse } from '../model/CheckRedeemResponse';
import { AuthorizationUtil, PlatformAuthorizer } from '@quickplay/platform-authorizer';

const X_DEVICE_ID_HEADER = 'X-Device-Id';

export function createCheckRedeemServiceImpl(
  checkRedeemEndPointUrl: string,
  platform: PlatformAuthorizer,
): CheckRedeemService {
  const checkRedeemService: CheckRedeemService = {
    checkRedeem(checkRedeemRequestData: CheckRedeemRequest, headers: HttpHeaders): Promise<string> {
      return checkRedeem(checkRedeemRequestData, checkRedeemRequestData.deviceToken, headers);
    },
  };

  async function checkRedeem(
    checkRedeemRequestData: CheckRedeemRequest,
    deviceToken: string,
    headers?: HttpHeaders,
  ): Promise<string> {
    try {
      const request = buildCheckRedeemRequest(checkRedeemRequestData, deviceToken, headers);
      const result = await AuthorizationUtil.makeAuthorizedRequest<any, CheckRedeemResponse>(request, platform);

      return result.data.token;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  function buildCheckRedeemRequest(
    checkRedeemRequestData: CheckRedeemRequest,
    deviceToken: string,
    headers?: HttpHeaders,
  ): HttpRequest<CheckRedeemRequest> {
    const defaultHeader: HttpHeaders = { [X_DEVICE_ID_HEADER]: deviceToken };
    return createRequestBuilder<CheckRedeemRequest>()
      .url(checkRedeemEndPointUrl)
      .headers(Object.assign(defaultHeader, headers))
      .path('/media/content/checkredeem')
      .post(checkRedeemRequestData)
      .build();
  }

  return checkRedeemService;
}
